module.exports = __webpack_public_path__ + "static/media/corona-recovered.f3fcdc14.jpg";